import React, { Component } from 'react';

import Analytics from 'APP_ROOT/services/analytics';
import CognitoUtil from '../../aws/cognito/cognitoUtil';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import HistoryUtil from '../../common/historyUtil';
import Events from '../../common/events';
import ChangePasswordModal from '../account/changePasswordModal';
import { strings, getCurrentLocale } from '../../../localization';
import globals from 'APP_ROOT/components/common/globals';

export default class NewPasswordPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            changePasswordModalOpen: true,
            changePasswordSuccess: null,
            changePasswordResponseMessage: null,
        };
    }

    componentDidMount() {
        Analytics.pageView();
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onChangePasswordSuccess = (e) => {

        console.log(e);

        LambdaUtil.finalizeAccount(this.props.user.stage, () => {
            HistoryUtil.push('/select-account');
        } , () => { // failure case
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
           window.location.href = "/?error=sign_in_account_details_error";
        });
    }

    closeChangePasswordModal = (e) => {
        e.preventDefault();

        // Clear saved user (current user) before going back to sign in page.
        // If not cleared, user will be directed to /dashboard since sessionManager directs saved
        // users (authenticated users --> CognitoUtil.getUser() == true) to dashboard from login page.
        CognitoUtil.logout();

        // Cancel?  Kick you out
        window.location.href = '/' + getCurrentLocale();
    }


    render() {

        var passRequired = CognitoUtil.newPasswordRequired();
        var cognitoNewPasswordRequired = false;

        if(passRequired === null || passRequired === false || !this.props.user)
        {
            // someone went to this "deep-link" without first attempting to log in
            // kick back to login page (render an empty tag, not null as that breaks)
            HistoryUtil.push('/');
            return <div></div>;
        }

        if(passRequired === 'cognito')
        {
            cognitoNewPasswordRequired = true;
        }

        return (
            <div id="loginPage" className="container login-page">
                <div className="container">
                    <ChangePasswordModal accountPage={this} 
                        title={strings.welcome}
                        message={
                            <div>
                                <p>{strings.new_user_password_change_welcome_message}</p>
                                <ul>{strings.new_user_you_can_access_the_following_resources}
                                    {globals.supportEmail ?
                                        <li>{strings.contact_us_email_label} <a href={"mailto:" + globals.supportEmail}>{globals.supportEmail}</a></li>
                                    :
                                        null
                                    }
                                    {globals.supportPhoneNumber ?
                                        <li><div>{strings.contact_us_phone_label} {globals.supportPhoneNumber}</div><small>{strings[globals.supportHoursDescriptionStringKey]}</small></li>
                                    :
                                        null
                                    }
                                    {globals.supportUrl ?
                                        <li>{strings.contact_us_website_label} <a href={globals.supportUrl}>{strings.support}</a> {strings.contact_us_website_contents_summary}</li>
                                        :
                                        null
                                    }
                                </ul>
                                <p>{strings.new_user_password_change_call_to_action}</p>
                            </div>
                        }
                        onChangePasswordSuccess={this.onChangePasswordSuccess} 
                        newPasswordRequired={true} 
                        cognitoNewPasswordRequired={cognitoNewPasswordRequired} 
                        oldPasswordRequired={false}
                        acceptTermsRequired={true}
                        op={this.props.op}
                    />
                </div>
            </div>
        );
    }
}
